var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.5;}.b{fill:#707070;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17,14.5a.5.5,0,0,0-1,0v4a.5.5,0,0,0,1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.5,16a.5.5,0,0,0,0,1h4a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10,19a8.991,8.991,0,1,1,8.44-5.868.5.5,0,0,0,.937.348,9.991,9.991,0,1,0-5.9,5.9.5.5,0,0,0-.348-.937A8.98,8.98,0,0,1,10,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10,13a12.392,12.392,0,0,1,4.119.64.5.5,0,1,0,.333-.943A13.382,13.382,0,0,0,10,12c-3.769,0-6.667,1.254-8.119,3.251a.5.5,0,0,0,.809.588C3.939,14.122,6.531,13,10,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14,7a4,4,0,1,0-4,4A4,4,0,0,0,14,7ZM7,7a3,3,0,1,1,3,3A3,3,0,0,1,7,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21,16.5A4.5,4.5,0,1,0,16.5,21,4.5,4.5,0,0,0,21,16.5Zm-8,0A3.5,3.5,0,1,1,16.5,20,3.5,3.5,0,0,1,13,16.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProfile);
export default __webpack_public_path__ + "static/media/add_profile.f410f8f26980ce8547799cb4a4dd8c96.svg";
export { ForwardRef as ReactComponent };